import React, { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type RemainingIndicatorPropsT = {
  children?: ReactNode;
  defaultSeconds: number;
  error?: boolean;
};

const style = {
  color: "var(--app-text-subtle)",
  marginTop: "10px",
  textAlign: "center",
} as React.CSSProperties;

export const RemainingIndicator = ({ children, defaultSeconds, error }: RemainingIndicatorPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.RemainingIndicator" });
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  });

  if (error) {
    return (
      <div style={style}>
        {children} {t("Not so good contact support")}
      </div>
    );
  }

  if (seconds < defaultSeconds) {
    return (
      <div style={style}>
        {children} {t("Remaning {{count}} seconds to finish", { count: defaultSeconds - seconds })}
      </div>
    );
  }
  if (seconds < defaultSeconds + 15) {
    return (
      <div style={style}>
        {children} {t("Just a little longer")}
      </div>
    );
  }

  if (seconds >= defaultSeconds + 15) {
    return (
      <div style={style}>
        {children} {t("We will surely finish it")}
      </div>
    );
  }
  return null;
};
